<template>
    <div class="form-activity-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Form Activity</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="section">
                    <div class="section-label">Contact Information</div>
                    <div class="section-container">
                        <div class="profile">
                            <div class="profile-container" @click="goToContact">
                                <img class="profile-image" :src="formActivity.profileImageUrl | profileImagePlaceholder" />
                                <p><strong>{{ formActivity.name }}</strong></p>
                            </div>
                            <strong>{{ (formActivity.company ? formActivity.company.name : '') | companyPlaceholder }}</strong>
                            <p>{{ formActivity.title }}</p>
                        </div>
                        <div class="info">
                            <div class="info-wrapper">
                                <div class="info-detail" v-if="formActivity.email">
                                    <label>Email</label>
                                    <a :href="`mailto:${ formActivity.email }`" target="_blank">{{ formActivity.email }}</a>
                                </div>
                                <div class="info-detail" v-if="formActivity.phone">
                                    <label>Phone</label>
                                    <a :href="`tel:${ formActivity.phone }`">{{ formActivity.phone }}</a>
                                </div>
                                <div class="info-detail" v-if="formActivity.linkedIn">
                                    <label>LinkedIn</label>
                                    <a :href="`${ formActivity.linkedIn }`" target="_blank">{{ formActivity.linkedIn }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="section-label">Form Submission</div>
                    <div class="section-container">
                        <p>{{formActivity.date}}</p>
                        <h3>{{formActivity.formType || 'N/A' }}</h3>
                        <p>{{formActivity.comment || 'N/A' }}</p>
                        
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="goToContact">Go to Contact</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'form-activity-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg
    },

    data() {
        return {
            formActivity: {
                id: this.widget.formActivityId,
                contactId: null,
                name: null,
                profileImageUrl: null,
                email: null,
                phone: null,
                title: null,
                linkedIn: null,
                temperatureRating: null,
                comment: null,
                formType: null,
                date: null,
                company: {
                    id: null,
                    company: null,
                }
            },
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        goToContact() {
            this.closeWidget();
            this.$router.push(`/Contacts/${ this.formActivity.contactId }`);
        },

        getFormInfo() {
            this.isLoading = true;
            this.$api
                .get(`/service/FormActivities?$filter=Id eq ${ this.formActivity.id }&$expand=Contact($expand=Company($select=Id,Name),SalesPerson,ContactStatus)`)
                .then(response => {
                    var formActivityResponse = response.data.value[0];
                    
                    this.formActivity.contactId = formActivityResponse.Contact.Id;
                    this.formActivity.name = this.$helpers.getName(formActivityResponse.Contact.FirstName, formActivityResponse.Contact.LastName);
                    this.formActivity.profileImageUrl = formActivityResponse.Contact.ProfileImageUrl;
                    this.formActivity.email = formActivityResponse.Contact.Email;
                    this.formActivity.phone = formActivityResponse.Contact.Phone;
                    this.formActivity.title = formActivityResponse.Contact.Title;
                    this.formActivity.linkedIn = formActivityResponse.Contact.LinkedinUrl;
                    this.formActivity.temperatureRating = formActivityResponse.Contact.TemperatureRating || 3;

                    this.formActivity.comment = formActivityResponse.FormComment;
                    this.formActivity.formType = formActivityResponse.FormType;
                    this.formActivity.date= this.$moment.utc(formActivityResponse.ActivityDate).local().format('MM/DD/YYYY');

                    this.formActivity.company = formActivityResponse.Contact.Company ? {
                        id: formActivityResponse.Contact.Company.Id,
                        name: formActivityResponse.Contact.Company.Name
                    } : null;
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while getting your form information.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

                                

    },

    created() {
        this.getFormInfo();
    }
}
</script>

<style>
.form-activity-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.form-activity-widget .cancel-btn:hover {
    background: #E1E0E5;
}

.form-activity-widget .section {
    margin-bottom: 1em;
}

.form-activity-widget .section-label {
    position: relative;
    bottom: -12px;
    width: fit-content;
    background: #ffffff;
    margin: 0 auto;
    font-weight: 500;
    padding: 0 47px;
}

.form-activity-widget .section-container {
    border: 2px solid #E9E9EF;
    border-radius: 22px;
    padding: 22px 32px;
}

.form-activity-widget .profile {
    text-align: center;
    margin-bottom: 1em;
}

.form-activity-widget .profile-container img {
    cursor: pointer;
}

.form-activity-widget .profile p {
    margin: 0 0 .25em 0;
}

.form-activity-widget .profile .profile-image {
    display: inline-block;
    max-width: 120px;
    border-radius: 50%;
    margin-bottom: .8em;
}

.form-activity-widget .info-detail {
    margin-bottom: .8em;
}

.form-activity-widget .info-detail label {
    display: block;
    margin: 0;
    color: #382153;
}

.form-activity-widget strong {
    display: inline-block;
}

</style>